// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared chrome for the standalone section pages that replaced the old
   Bot Settings / Activity tab shells. */

/* Behaviour page retired → blurred + inert, with a "moved to Studio" overlay. */
.behavior-moved-wrap { position: relative; min-height: 420px; }
.behavior-moved-blur { filter: blur(5px); opacity: 0.5; pointer-events: none; -webkit-user-select: none; user-select: none; }
.behavior-moved-mock { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 14px; padding: 4px; }
.behavior-moved-card { border: 1px solid #e6e0f5; border-radius: 10px; background: #fff; padding: 16px; display: flex; flex-direction: column; gap: 10px; }
.behavior-moved-line { height: 12px; border-radius: 6px; background: #ece9f5; }
.behavior-moved-line.lg { width: 60%; height: 16px; }
.behavior-moved-line.sm { width: 40%; }
.behavior-moved-overlay {
  position: absolute; inset: 0; z-index: 2;
  display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
  gap: 12px; padding: 24px;
}
.behavior-moved-overlay h2 { margin: 0; font-size: 1.5rem; font-weight: 800; color: #1b1233; }
.behavior-moved-overlay p { margin: 0; max-width: 520px; color: #5d5775; line-height: 1.5; }
.behavior-moved-badge {
  display: inline-flex; align-items: center; gap: 7px; font-size: 0.74rem; font-weight: 600;
  color: #5616ea; background: rgba(124, 58, 237, 0.1); border: 1px solid rgba(124, 58, 237, 0.2);
  padding: 5px 12px; border-radius: 999px;
}
.behavior-moved-cta {
  display: inline-flex; align-items: center; gap: 8px; margin-top: 6px;
  background: #5616ea; color: #fff; text-decoration: none; border-radius: 11px;
  padding: 11px 20px; font-weight: 700; transition: background 0.15s, box-shadow 0.15s, transform 0.15s;
}
.behavior-moved-cta:hover { background: #4711c2; box-shadow: 0 6px 18px rgba(86, 22, 234, 0.3); transform: translateY(-1px); }

/* Lead Generation page reuses the moved-overlay chrome, but its blurred backdrop
   is the REAL warm-lead config. Let it span the full page width (drop the section
   shell's max-width so the form fills behind the centered overlay instead of
   leaving it stranded right), cap the peeked height, and fade ALL FOUR edges so
   the blur reads as a soft frosted panel rather than a hard, kantig clip. */
.lead-gen-moved.section-shell { max-width: none; }
.lead-gen-moved .warm-lead-parent-container,
.lead-gen-moved .warm-lead-container { max-width: none; width: 100%; }
.lead-gen-moved .behavior-moved-wrap {
  overflow: hidden;
  border-radius: 16px;
}
/* The height cap lives on the BLURRED element itself (not the wrap), so the
   element box ends exactly at the visible cutoff — that's what the mask's
   \`100%\` resolves to, so the bottom fade lands on the real edge instead of far
   below it (where the wrap used to clip with a hard line). */
.lead-gen-moved .behavior-moved-blur {
  max-height: 600px;
  overflow: hidden;
  filter: blur(6px);
  opacity: 0.45;
  -webkit-mask-image:
    linear-gradient(to bottom, transparent 0, #000 48px, #000 calc(100% - 96px), transparent 100%),
    linear-gradient(to right, transparent 0, #000 44px, #000 calc(100% - 44px), transparent 100%);
  -webkit-mask-composite: source-in;
  mask-image:
    linear-gradient(to bottom, transparent 0, #000 48px, #000 calc(100% - 96px), transparent 100%),
    linear-gradient(to right, transparent 0, #000 44px, #000 calc(100% - 44px), transparent 100%);
  mask-composite: intersect;
}

.section-page {
  /* \`.bot-settings\` already provides the page padding; this is just a
     hook for section-specific tweaks. */
}

.section-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: #5616ea;
  font-size: 22px;
}

/* Shared page shell: mirror the Channels/Apps page's outer spacing exactly.
   Used by Agent Studio (Skills/Behavior), Design, Activity, Reporting, etc. */
.section-shell {
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  padding: 22px 24px 48px;
}

/* These pages also carry \`.bot-settings\`, which sets \`margin: 20px\` and would
   otherwise shove the whole page ~20px right of the Apps/Channels spacing.
   Relying on source order to win is fragile (\`.bot-settings\` is defined in
   more than one stylesheet), so win on specificity instead. */
.bot-settings.section-shell {
  margin: 0 auto;
}

/* Page header (title + subtitle), mirrors the Channels page header. */
.section-head {
  margin-bottom: 18px;
  font-family: "DM Sans", sans-serif;
}
.section-head-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #20202a;
}
.section-head-sub {
  margin: 4px 0 0;
  font-size: 13.5px;
  color: #82828e;
}
/* Header row variant: title/subtitle on the left, a control (the date picker)
   on the right (Activity: Insights / Inbox / Leads). */
.section-head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.section-head-row .date-range-bar {
  margin-bottom: 0;
}

/* ── Knowledge Base usage bar (top-right of every KB section header) ──── */
.kb-usage {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  border: 1px solid #e4e4ea;
  border-radius: 10px;
  background: #fff;
  font-family: "DM Sans", sans-serif;
  flex-shrink: 0;
  /* Include the padding + border in the width: when the bar goes full-width on
     mobile (.section-head-row .kb-usage { width: 100% }) without this it
     overflows the page ~30px to the right and triggers a horizontal scrollbar
     (which in turn induces a small phantom vertical scroll). */
  box-sizing: border-box;
}
.kb-usage-label {
  font-size: 13px;
  font-weight: 500;
  color: #4a4a55;
  white-space: nowrap;
}
.kb-usage-track {
  position: relative;
  width: 130px;
  height: 7px;
  border-radius: 999px;
  background: #efecf9;
  overflow: hidden;
  flex-shrink: 0;
}
.kb-usage-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: #5616ea;
  transition: width 0.5s ease;
}
.kb-usage-fill-full {
  background: #ef4444;
}
.kb-usage-pct {
  min-width: 32px;
  font-size: 12.5px;
  font-weight: 600;
  color: #82828e;
  white-space: nowrap;
  text-align: right;
}
/* Upgrade CTA — only at the limit, and only when a higher tier exists. Same
   action as KnowledgeUpgradeModal's "Upgrade Now" (mirrors .studio-usage-upgrade
   in the AI Studio bar). */
.kb-usage-upgrade {
  flex-shrink: 0;
  padding: 5px 12px;
  border: none;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease;
}
.kb-usage-upgrade:hover:not(:disabled) {
  background: #4712c4;
}
.kb-usage-upgrade:disabled {
  opacity: 0.6;
  cursor: default;
}
/* On a wrapped (narrow) header, let the bar take the full row and the track
   grow to fill it. */
@media (max-width: 768px) {
  .section-head-row .kb-usage {
    width: 100%;
  }
  .section-head-row .kb-usage-track {
    flex: 1 1;
    width: auto;
  }
}
/* Match the Channels/Design gap between the header and the first content
   element. The Activity/Reporting content roots carry a 30px top margin left
   over from the old tab shells; drop it inside the section shell so the only
   gap is the header's own margin-bottom (18px). */
.section-shell > .analytics-dashboard,
.section-shell > .leads-root-min,
.section-shell > .reporting-parent {
  margin-top: 0;
}

/* ── Date range picker (Activity: Inbox / Insights / Leads) ─────────── */
.date-range-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}
.date-range-trigger {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 14px;
  border: 1px solid #e4e4ea;
  border-radius: 9px;
  background: #fff;
  color: #4a4a55;
  font-family: "DM Sans", sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.date-range-trigger:hover {
  border-color: #cbb9f4;
  background: #faf8ff;
}
.date-range-trigger-icon {
  color: #5616ea;
  font-size: 14px;
}

/* react-datepicker — company purple theme */
/* Rendered in a body-level portal (portalId) and lifted above everything
   (charts/KPIs) so nothing overlaps the open calendar. */
.ub-datepicker-popper {
  z-index: 9999;
}
#ub-datepicker-portal {
  position: relative;
  z-index: 9999;
}
.ub-datepicker {
  font-family: "DM Sans", sans-serif;
  border: 1px solid #ececf1;
  border-radius: 12px;
  box-shadow: 0 14px 38px -16px rgba(20, 10, 50, 0.35);
  padding: 8px 10px;
  color: #2b2b35;
}
.ub-datepicker .react-datepicker__header {
  background: #fff;
  border-bottom: none;
  padding-top: 8px;
}
/* Custom header (renderCustomHeader): bordered nav buttons aligned with the
   month label. */
.ub-dp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px 8px;
}
.ub-dp-month {
  font-size: 14px;
  font-weight: 700;
  color: #20202a;
}
.ub-dp-nav {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #e4e4ea;
  border-radius: 8px;
  background: #fff;
  color: #5a5a66;
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.ub-dp-nav:hover {
  border-color: #cbb9f4;
  background: #faf8ff;
  color: #5616ea;
}
.ub-datepicker .react-datepicker__day,
.ub-datepicker .react-datepicker__day-name {
  width: 2rem;
  line-height: 2rem;
  margin: 2px 0;
}
.ub-datepicker .react-datepicker__day-name {
  color: #9a96ab;
  font-weight: 600;
}
.ub-datepicker .react-datepicker__day {
  color: #2b2b35;
  border-radius: 8px;
}
.ub-datepicker .react-datepicker__day:hover {
  background: #f1ecff;
  border-radius: 8px;
}
.ub-datepicker .react-datepicker__day--outside-month {
  color: #c8c8d2;
}
.ub-datepicker .react-datepicker__day--in-range,
.ub-datepicker .react-datepicker__day--in-selecting-range {
  background-color: #ece7fb !important;
  color: #2b2b35 !important;
  border-radius: 0;
}
/* Keyboard focus shouldn't masquerade as a selection. */
.ub-datepicker .react-datepicker__day--keyboard-selected {
  background-color: transparent;
  color: #2b2b35;
}
/* Selected endpoints — solid purple, fully rounded (force over the
   react-datepicker defaults). */
.ub-datepicker .react-datepicker__day--selected,
.ub-datepicker .react-datepicker__day--range-start,
.ub-datepicker .react-datepicker__day--range-end,
.ub-datepicker .react-datepicker__day--selecting-range-start,
.ub-datepicker .react-datepicker__day--selecting-range-end {
  background-color: #5616ea !important;
  color: #fff !important;
  border-radius: 8px !important;
}
.ub-datepicker .react-datepicker__day--today {
  font-weight: 700;
}
/* Authoritative range highlight driven entirely by our own logic:
   \`ub-day-*\` is the committed range (via dayClassName), \`ub-preview-*\` is the
   live in-progress preview (painted imperatively on hover). Both directions
   look identical because neither relies on react-datepicker's forward-only
   internal state. */
.ub-datepicker .react-datepicker__day.ub-day-mid,
.ub-datepicker .react-datepicker__day.ub-preview-mid {
  background-color: #ece7fb !important;
  color: #2b2b35 !important;
  border-radius: 0 !important;
}
.ub-datepicker .react-datepicker__day.ub-day-edge,
.ub-datepicker .react-datepicker__day.ub-preview-edge {
  background-color: #5616ea !important;
  color: #fff !important;
  border-radius: 8px !important;
}

/* ── Knowledge Base: platform-app leaves (Wix / Shopify) ───────────────────
   These sections are fed by a connected app rather than by uploaded sources, so
   the header carries the app's own mark and — unlike every other KB leaf — no
   usage bar: the shared source quota deliberately excludes mirrored catalogs and
   CMS collections, so a bar here would report a number this page cannot move. */
.kb-provider-head {
  display: flex;
  align-items: center;
  gap: 13px;
}

.kb-provider-head-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ece7f6;
  box-shadow: 0 2px 8px -6px rgba(36, 27, 61, 0.4);
}

.kb-provider-unbound {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 26px;
  background: #fff;
  border: 1px solid #ece7f6;
  border-radius: 16px;
}
.kb-provider-unbound p {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.55;
  color: #7b7497;
  max-width: 58ch;
}
.kb-provider-unbound-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 0.83rem;
  font-weight: 600;
  color: #5616ea;
  text-decoration: none;
}
.kb-provider-unbound-link svg {
  font-size: 0.75rem;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.kb-provider-unbound-link:hover svg { transform: translateX(3px); }
`, "",{"version":3,"sources":["webpack://./src/pages/sectionPages.css"],"names":[],"mappings":"AAAA;wCACwC;;AAExC,gFAAgF;AAChF,uBAAuB,kBAAkB,EAAE,iBAAiB,EAAE;AAC9D,uBAAuB,iBAAiB,EAAE,YAAY,EAAE,oBAAoB,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AACjG,uBAAuB,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE,YAAY,EAAE;AAC7H,uBAAuB,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC1J,uBAAuB,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9E,0BAA0B,UAAU,EAAE,YAAY,EAAE;AACpD,0BAA0B,UAAU,EAAE;AACtC;EACE,kBAAkB,EAAE,QAAQ,EAAE,UAAU;EACxC,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB;EACvG,SAAS,EAAE,aAAa;AAC1B;AACA,6BAA6B,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7F,4BAA4B,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,gBAAgB;EACzF,cAAc,EAAE,mCAAmC,EAAE,yCAAyC;EAC9F,iBAAiB,EAAE,oBAAoB;AACzC;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe;EACpE,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE,mBAAmB;EAC5E,kBAAkB,EAAE,gBAAgB,EAAE,+DAA+D;AACvG;AACA,4BAA4B,mBAAmB,EAAE,6CAA6C,EAAE,2BAA2B,EAAE;;AAE7H;;;;4EAI4E;AAC5E,gCAAgC,eAAe,EAAE;AACjD;uCACuC,eAAe,EAAE,WAAW,EAAE;AACrE;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;6DAG6D;AAC7D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb;;iGAE+F;EAC/F,iCAAiC;EACjC;;iGAE+F;EAC/F,yBAAyB;AAC3B;;AAEA;EACE;wCACsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;8EAC8E;AAC9E;EACE,wCAAwC;EACxC,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;8DAG8D;AAC9D;EACE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;uDACuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd;;;+DAG6D;EAC7D,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;2BAE2B;AAC3B;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;qBACqB;AACrB;EACE;IACE,WAAW;EACb;EACA;IACE,SAAO;IACP,WAAW;EACb;AACF;AACA;;;kDAGkD;AAClD;;;EAGE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;yDACyD;AACzD;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;iBACiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yEAAyE;AAC3E;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;AACA,wDAAwD;AACxD;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;gCACgC;AAChC;;;;;EAKE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;;;;oBAIoB;AACpB;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;;gFAIgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA,sCAAsC,0BAA0B,EAAE","sourcesContent":["/* Shared chrome for the standalone section pages that replaced the old\r\n   Bot Settings / Activity tab shells. */\r\n\r\n/* Behaviour page retired → blurred + inert, with a \"moved to Studio\" overlay. */\r\n.behavior-moved-wrap { position: relative; min-height: 420px; }\r\n.behavior-moved-blur { filter: blur(5px); opacity: 0.5; pointer-events: none; user-select: none; }\r\n.behavior-moved-mock { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 14px; padding: 4px; }\r\n.behavior-moved-card { border: 1px solid #e6e0f5; border-radius: 10px; background: #fff; padding: 16px; display: flex; flex-direction: column; gap: 10px; }\r\n.behavior-moved-line { height: 12px; border-radius: 6px; background: #ece9f5; }\r\n.behavior-moved-line.lg { width: 60%; height: 16px; }\r\n.behavior-moved-line.sm { width: 40%; }\r\n.behavior-moved-overlay {\r\n  position: absolute; inset: 0; z-index: 2;\r\n  display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;\r\n  gap: 12px; padding: 24px;\r\n}\r\n.behavior-moved-overlay h2 { margin: 0; font-size: 1.5rem; font-weight: 800; color: #1b1233; }\r\n.behavior-moved-overlay p { margin: 0; max-width: 520px; color: #5d5775; line-height: 1.5; }\r\n.behavior-moved-badge {\r\n  display: inline-flex; align-items: center; gap: 7px; font-size: 0.74rem; font-weight: 600;\r\n  color: #5616ea; background: rgba(124, 58, 237, 0.1); border: 1px solid rgba(124, 58, 237, 0.2);\r\n  padding: 5px 12px; border-radius: 999px;\r\n}\r\n.behavior-moved-cta {\r\n  display: inline-flex; align-items: center; gap: 8px; margin-top: 6px;\r\n  background: #5616ea; color: #fff; text-decoration: none; border-radius: 11px;\r\n  padding: 11px 20px; font-weight: 700; transition: background 0.15s, box-shadow 0.15s, transform 0.15s;\r\n}\r\n.behavior-moved-cta:hover { background: #4711c2; box-shadow: 0 6px 18px rgba(86, 22, 234, 0.3); transform: translateY(-1px); }\r\n\r\n/* Lead Generation page reuses the moved-overlay chrome, but its blurred backdrop\r\n   is the REAL warm-lead config. Let it span the full page width (drop the section\r\n   shell's max-width so the form fills behind the centered overlay instead of\r\n   leaving it stranded right), cap the peeked height, and fade ALL FOUR edges so\r\n   the blur reads as a soft frosted panel rather than a hard, kantig clip. */\r\n.lead-gen-moved.section-shell { max-width: none; }\r\n.lead-gen-moved .warm-lead-parent-container,\r\n.lead-gen-moved .warm-lead-container { max-width: none; width: 100%; }\r\n.lead-gen-moved .behavior-moved-wrap {\r\n  overflow: hidden;\r\n  border-radius: 16px;\r\n}\r\n/* The height cap lives on the BLURRED element itself (not the wrap), so the\r\n   element box ends exactly at the visible cutoff — that's what the mask's\r\n   `100%` resolves to, so the bottom fade lands on the real edge instead of far\r\n   below it (where the wrap used to clip with a hard line). */\r\n.lead-gen-moved .behavior-moved-blur {\r\n  max-height: 600px;\r\n  overflow: hidden;\r\n  filter: blur(6px);\r\n  opacity: 0.45;\r\n  -webkit-mask-image:\r\n    linear-gradient(to bottom, transparent 0, #000 48px, #000 calc(100% - 96px), transparent 100%),\r\n    linear-gradient(to right, transparent 0, #000 44px, #000 calc(100% - 44px), transparent 100%);\r\n  -webkit-mask-composite: source-in;\r\n  mask-image:\r\n    linear-gradient(to bottom, transparent 0, #000 48px, #000 calc(100% - 96px), transparent 100%),\r\n    linear-gradient(to right, transparent 0, #000 44px, #000 calc(100% - 44px), transparent 100%);\r\n  mask-composite: intersect;\r\n}\r\n\r\n.section-page {\r\n  /* `.bot-settings` already provides the page padding; this is just a\r\n     hook for section-specific tweaks. */\r\n}\r\n\r\n.section-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 60vh;\r\n  color: #5616ea;\r\n  font-size: 22px;\r\n}\r\n\r\n/* Shared page shell: mirror the Channels/Apps page's outer spacing exactly.\r\n   Used by Agent Studio (Skills/Behavior), Design, Activity, Reporting, etc. */\r\n.section-shell {\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  padding: 22px 24px 48px;\r\n}\r\n\r\n/* These pages also carry `.bot-settings`, which sets `margin: 20px` and would\r\n   otherwise shove the whole page ~20px right of the Apps/Channels spacing.\r\n   Relying on source order to win is fragile (`.bot-settings` is defined in\r\n   more than one stylesheet), so win on specificity instead. */\r\n.bot-settings.section-shell {\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Page header (title + subtitle), mirrors the Channels page header. */\r\n.section-head {\r\n  margin-bottom: 18px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n}\r\n.section-head-title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.section-head-sub {\r\n  margin: 4px 0 0;\r\n  font-size: 13.5px;\r\n  color: #82828e;\r\n}\r\n/* Header row variant: title/subtitle on the left, a control (the date picker)\r\n   on the right (Activity: Insights / Inbox / Leads). */\r\n.section-head-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n.section-head-row .date-range-bar {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* ── Knowledge Base usage bar (top-right of every KB section header) ──── */\r\n.kb-usage {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 8px 14px;\r\n  border: 1px solid #e4e4ea;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  flex-shrink: 0;\r\n  /* Include the padding + border in the width: when the bar goes full-width on\r\n     mobile (.section-head-row .kb-usage { width: 100% }) without this it\r\n     overflows the page ~30px to the right and triggers a horizontal scrollbar\r\n     (which in turn induces a small phantom vertical scroll). */\r\n  box-sizing: border-box;\r\n}\r\n.kb-usage-label {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #4a4a55;\r\n  white-space: nowrap;\r\n}\r\n.kb-usage-track {\r\n  position: relative;\r\n  width: 130px;\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  background: #efecf9;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n.kb-usage-fill {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  background: #5616ea;\r\n  transition: width 0.5s ease;\r\n}\r\n.kb-usage-fill-full {\r\n  background: #ef4444;\r\n}\r\n.kb-usage-pct {\r\n  min-width: 32px;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: #82828e;\r\n  white-space: nowrap;\r\n  text-align: right;\r\n}\r\n/* Upgrade CTA — only at the limit, and only when a higher tier exists. Same\r\n   action as KnowledgeUpgradeModal's \"Upgrade Now\" (mirrors .studio-usage-upgrade\r\n   in the AI Studio bar). */\r\n.kb-usage-upgrade {\r\n  flex-shrink: 0;\r\n  padding: 5px 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-family: inherit;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.kb-usage-upgrade:hover:not(:disabled) {\r\n  background: #4712c4;\r\n}\r\n.kb-usage-upgrade:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n/* On a wrapped (narrow) header, let the bar take the full row and the track\r\n   grow to fill it. */\r\n@media (max-width: 768px) {\r\n  .section-head-row .kb-usage {\r\n    width: 100%;\r\n  }\r\n  .section-head-row .kb-usage-track {\r\n    flex: 1;\r\n    width: auto;\r\n  }\r\n}\r\n/* Match the Channels/Design gap between the header and the first content\r\n   element. The Activity/Reporting content roots carry a 30px top margin left\r\n   over from the old tab shells; drop it inside the section shell so the only\r\n   gap is the header's own margin-bottom (18px). */\r\n.section-shell > .analytics-dashboard,\r\n.section-shell > .leads-root-min,\r\n.section-shell > .reporting-parent {\r\n  margin-top: 0;\r\n}\r\n\r\n/* ── Date range picker (Activity: Inbox / Insights / Leads) ─────────── */\r\n.date-range-bar {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-bottom: 14px;\r\n}\r\n.date-range-trigger {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 9px 14px;\r\n  border: 1px solid #e4e4ea;\r\n  border-radius: 9px;\r\n  background: #fff;\r\n  color: #4a4a55;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 13.5px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease, background 0.2s ease;\r\n}\r\n.date-range-trigger:hover {\r\n  border-color: #cbb9f4;\r\n  background: #faf8ff;\r\n}\r\n.date-range-trigger-icon {\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n}\r\n\r\n/* react-datepicker — company purple theme */\r\n/* Rendered in a body-level portal (portalId) and lifted above everything\r\n   (charts/KPIs) so nothing overlaps the open calendar. */\r\n.ub-datepicker-popper {\r\n  z-index: 9999;\r\n}\r\n#ub-datepicker-portal {\r\n  position: relative;\r\n  z-index: 9999;\r\n}\r\n.ub-datepicker {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  border: 1px solid #ececf1;\r\n  border-radius: 12px;\r\n  box-shadow: 0 14px 38px -16px rgba(20, 10, 50, 0.35);\r\n  padding: 8px 10px;\r\n  color: #2b2b35;\r\n}\r\n.ub-datepicker .react-datepicker__header {\r\n  background: #fff;\r\n  border-bottom: none;\r\n  padding-top: 8px;\r\n}\r\n/* Custom header (renderCustomHeader): bordered nav buttons aligned with the\r\n   month label. */\r\n.ub-dp-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 2px 8px;\r\n}\r\n.ub-dp-month {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.ub-dp-nav {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 1px solid #e4e4ea;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #5a5a66;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;\r\n}\r\n.ub-dp-nav:hover {\r\n  border-color: #cbb9f4;\r\n  background: #faf8ff;\r\n  color: #5616ea;\r\n}\r\n.ub-datepicker .react-datepicker__day,\r\n.ub-datepicker .react-datepicker__day-name {\r\n  width: 2rem;\r\n  line-height: 2rem;\r\n  margin: 2px 0;\r\n}\r\n.ub-datepicker .react-datepicker__day-name {\r\n  color: #9a96ab;\r\n  font-weight: 600;\r\n}\r\n.ub-datepicker .react-datepicker__day {\r\n  color: #2b2b35;\r\n  border-radius: 8px;\r\n}\r\n.ub-datepicker .react-datepicker__day:hover {\r\n  background: #f1ecff;\r\n  border-radius: 8px;\r\n}\r\n.ub-datepicker .react-datepicker__day--outside-month {\r\n  color: #c8c8d2;\r\n}\r\n.ub-datepicker .react-datepicker__day--in-range,\r\n.ub-datepicker .react-datepicker__day--in-selecting-range {\r\n  background-color: #ece7fb !important;\r\n  color: #2b2b35 !important;\r\n  border-radius: 0;\r\n}\r\n/* Keyboard focus shouldn't masquerade as a selection. */\r\n.ub-datepicker .react-datepicker__day--keyboard-selected {\r\n  background-color: transparent;\r\n  color: #2b2b35;\r\n}\r\n/* Selected endpoints — solid purple, fully rounded (force over the\r\n   react-datepicker defaults). */\r\n.ub-datepicker .react-datepicker__day--selected,\r\n.ub-datepicker .react-datepicker__day--range-start,\r\n.ub-datepicker .react-datepicker__day--range-end,\r\n.ub-datepicker .react-datepicker__day--selecting-range-start,\r\n.ub-datepicker .react-datepicker__day--selecting-range-end {\r\n  background-color: #5616ea !important;\r\n  color: #fff !important;\r\n  border-radius: 8px !important;\r\n}\r\n.ub-datepicker .react-datepicker__day--today {\r\n  font-weight: 700;\r\n}\r\n/* Authoritative range highlight driven entirely by our own logic:\r\n   `ub-day-*` is the committed range (via dayClassName), `ub-preview-*` is the\r\n   live in-progress preview (painted imperatively on hover). Both directions\r\n   look identical because neither relies on react-datepicker's forward-only\r\n   internal state. */\r\n.ub-datepicker .react-datepicker__day.ub-day-mid,\r\n.ub-datepicker .react-datepicker__day.ub-preview-mid {\r\n  background-color: #ece7fb !important;\r\n  color: #2b2b35 !important;\r\n  border-radius: 0 !important;\r\n}\r\n.ub-datepicker .react-datepicker__day.ub-day-edge,\r\n.ub-datepicker .react-datepicker__day.ub-preview-edge {\r\n  background-color: #5616ea !important;\r\n  color: #fff !important;\r\n  border-radius: 8px !important;\r\n}\r\n\r\n/* ── Knowledge Base: platform-app leaves (Wix / Shopify) ───────────────────\r\n   These sections are fed by a connected app rather than by uploaded sources, so\r\n   the header carries the app's own mark and — unlike every other KB leaf — no\r\n   usage bar: the shared source quota deliberately excludes mirrored catalogs and\r\n   CMS collections, so a bar here would report a number this page cannot move. */\r\n.kb-provider-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 13px;\r\n}\r\n\r\n.kb-provider-head-mark {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 44px;\r\n  height: 44px;\r\n  flex-shrink: 0;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  border: 1px solid #ece7f6;\r\n  box-shadow: 0 2px 8px -6px rgba(36, 27, 61, 0.4);\r\n}\r\n\r\n.kb-provider-unbound {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 26px;\r\n  background: #fff;\r\n  border: 1px solid #ece7f6;\r\n  border-radius: 16px;\r\n}\r\n.kb-provider-unbound p {\r\n  margin: 0;\r\n  font-size: 0.86rem;\r\n  line-height: 1.55;\r\n  color: #7b7497;\r\n  max-width: 58ch;\r\n}\r\n.kb-provider-unbound-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 0.83rem;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n}\r\n.kb-provider-unbound-link svg {\r\n  font-size: 0.75rem;\r\n  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n.kb-provider-unbound-link:hover svg { transform: translateX(3px); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
